import { useEffect, useState } from 'react';
import '../../styles/FAQ.css';
import '../../styles/Navigation.css';
import Navbar from '../../components/player/Navbar.tsx';
import Footer from '../../components/player/Footer.jsx';
import { showFAQ } from '../../services/player/FAQService.tsx';
import { FAQ } from '../../models/FAQ.tsx';
import { usePlayerChrome } from '../../hooks/usePlayerChrome.ts';

function FrequentQuestions() {
    usePlayerChrome();

    const [faq, setFaq] = useState<FAQ[]>([]);
    const [activeIndices, setActiveIndices] = useState<number[]>([]);

    const toggleAccordion = (index: number) => {
        if (activeIndices.includes(index)) {
            setActiveIndices(activeIndices.filter((i) => i !== index));
        } else {
            setActiveIndices([...activeIndices, index]);
        }
    };

    const loadFAQ = async () => {
        const quetions = await showFAQ();
        setFaq(quetions);
    }

    useEffect(() => {
        loadFAQ();
    }, []);

    return (
        <div className="player-layout">
            <Navbar />
            <div className='container-fluid spacing player-main-surface'>
                <div className='row'>
                    <div className='col-lg-12 col-xs-12'>
                        <div className='FAQ-container'>
                            <span className='teko FAQ'>FREQUENTLY ASKED QUESTIONS</span>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-lg-11 col-xs-12'>
                        <div className="accordion">
                            {faq.map((item, index) => (
                                <div className="accordion-item" key={index}>
                                    <div className={`accordion-title teko ${activeIndices.includes(index) ? 'active' : ''}`} onClick={() => toggleAccordion(index)}>
                                        {item.order} - {item.title}
                                    </div>
                                    <div className={`accordion-content teko ${activeIndices.includes(index) ? 'active' : ''}`}>
                                        {item.content}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default FrequentQuestions;
